import React from 'react';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import type { SearchAllContentArticleHit as Type } from '../../../../SearchAllContent/types';
import constructVariableRatiosImageSourcesObject from '../../../../../helpers/constructImageSources';

import NodeArticleCard from '../../../../../implementations/Node/Article/Card';

const MetaSearchArticleHit: React.FC<{ hit: Type }> = ({ hit }) => (
  <NodeArticleCard
    title={hit.page_title[0]}
    subtitle={hit.body_summarized?.[0] || hit.body?.[0] || hit.paragraphs_body_processed?.[0]}
    image={(
      <Image
        src={constructVariableRatiosImageSourcesObject(
          hit,
          ['16_9', '1_1', '4_3', '4_3', '4_3'],
          ['sm', 'xxs', 'xs', 'sm', 'sm'],
        )}
        alt=""
        lazyload={false}
      />
    )}
    link={hit.url[0]}
    publicationDate={hit.publish_date[0] * 1000}
    type={hit.article_type_name[0]}
    themes={hit.themes_name}
    langcode={hit.langcode[0]}
  />
);

export default MetaSearchArticleHit;
